






























import { Component, Vue } from 'vue-property-decorator';
import {AnfrageService} from "@/services/Beschwerdemanagement/anfrage-service";
import {Anfrage} from "@/models/Beschwerdemanagement/anfrage-model";

@Component({
    components: {}
})
export default class AnfrageWrapper extends Vue {

    public anfrageService!: AnfrageService;
    public id: number = 0;
    public anfrage: Anfrage = new Anfrage();
    public loading: boolean = true;

    async created() {
        this.anfrageService = new AnfrageService();
        this.id = (<any>this.$route.params).id;
        window.addEventListener('scroll', this.handleScroll);
    }

    async mounted() {
        //ggf. Tätigkeit laden, falls etwas im Tabstrip oder oben angezeigt werden soll
        this.anfrage = await this.anfrageService.GetById(this.id);
        this.loading = false;
    }

    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(a:any) {
        if (window.scrollY > 25) {
            (this.$refs.scrollEl as HTMLElement).setAttribute("style", "padding-top: 20px;");
        } else {
            (this.$refs.scrollEl as HTMLElement).setAttribute("style", "padding-top: 00px;");
        }
    }
}
